import { render } from "./SellerList.vue?vue&type=template&id=5b4fcc06"
import script from "./SellerList.vue?vue&type=script&lang=js"
export * from "./SellerList.vue?vue&type=script&lang=js"

import "./SellerList.vue?vue&type=style&index=0&id=5b4fcc06&lang=css"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__